import { Deserializable } from '../../protocols/deserializable';
import { MfaType } from '../../types/dto/mfa-type';
import { UserRoleResponse } from '../../roles/user-role-response';
import { LookAheadItem } from '../../../views/shared/components/search-with-look-ahead/look-ahead-list/look-ahead-item/protocol/look-ahead-item';

export class EmployerUserRecord implements Deserializable, LookAheadItem {
  public id!: number;
  public employerId!: number;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public mfaTypeId!: number;
  public sortRoleName!: string;
  public passwordChangedDate!: string | null;
  public eulaAccepted!: boolean;
  public eulaAcceptedDate!: string | null;
  public lastLoginDate!: string | null;
  public active!: boolean;
  public setInactiveDate!: string | null;
  public setInactiveById!: number | null;
  public setInactiveByName!: string | null;
  public setInactiveByUserType!: string | null;
  public mfaType!: MfaType;
  public roles!: UserRoleResponse[];

  lookAheadDisabled(): boolean {
    return false;
  }

  lookAheadDisabledMessage(): string {
    return '';
  }

  lookAheadDisplayValue(): string {
    return `${this.firstName} - ${this.lastName}`;
  }

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    if (!!this.mfaType) {
      this.mfaType = Deserialize?.instanceOf(MfaType, this.mfaType);
    }
    if (!!this.roles) {
      this.roles = Deserialize?.arrayOf(UserRoleResponse, this.roles);
    }
  }
}
